module.exports = __webpack_public_path__ + "img/dashed_05.dcbdec44.png";